import { FC } from 'react'
import { Stack } from '@mui/material'
import { ColorScaleItem } from '../ColorScaleItem'
interface ColorScalesProps {
  values: number[]
  colors: string[]
  selectedParameterRanges: {
    allowable_range:[number, number] | null,
    values:{ value: number; color: string }[]
  } | null
  selectedValue?: number
}

export const ColorScales: FC<ColorScalesProps> = ({ selectedValue, values, selectedParameterRanges, colors }) => {
  
  if (!values.length || !colors.length ) return null

  return (
    <Stack>
      <Stack direction="row" spacing={0} justifyContent="flex-start">
        {selectedParameterRanges &&
          selectedParameterRanges.values.map((value, index) => (
            <ColorScaleItem
              key={index + 1}
              value={value.value}
              color={value.color}
              prevValue={
                selectedParameterRanges.values[index - 1] &&
                selectedParameterRanges.values[index - 1].value
              }
              range={selectedParameterRanges.allowable_range}
              isSelected={selectedValue === value.value}
            />
          ))}

        <Stack
          direction="row"
          sx={{
            flex: '3 !important',
          }}
        ></Stack>
      </Stack>
    </Stack>
  )
}
